import { Outlet } from 'react-router-dom'

import { CurrencyContextProvider } from 'modules/compensations/lib/CurrencyContext'
import { PayrollRunsProvider } from 'modules/compensations/lib/PayrollRunsContext'

const CyclesPage = () => {
  return (
    <PayrollRunsProvider>
      <CurrencyContextProvider>
        <Outlet />
      </CurrencyContextProvider>
    </PayrollRunsProvider>
  )
}

export default CyclesPage
